import {
  Text,
  IconReceiptBill,
  IconCircleX,
  Button,
  GreyGrey70,
  Link,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

import { toMoney } from '@sequencehq/utils'

import { InvoicePreviewCard, NodeTimeline } from 'Automations/components'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { CustomerPreviewCardPill } from 'Customer/components/CustomerPreviewCard'
import { invoicePaths } from 'Invoices/invoices.router'
import { getHumanReadableInvoiceNumber } from 'Invoices/utils'
import { TaskInput } from './types'
import { useInvoiceData } from '../../hooks/useInvoiceData'

export const InvoiceAutoIssueFailedPreview = (props: { taskId: string }) => {
  const { manualTask } = useManualTask({ taskId: props.taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { invoice, customer, invoiceDetails } = useInvoiceData(input?.invoiceId)

  const hasInvoiceData = invoice && customer && invoiceDetails

  return (
    <>
      <NodeTimeline.Item icon={<IconReceiptBill />} showStem>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label="Invoice created"
            timestamp={invoice?.createdAt}
          />
        </NodeTimeline.Title>

        {hasInvoiceData && (
          <InvoicePreviewCard
            invoice={invoice}
            customer={customer}
            invoiceDetails={invoiceDetails}
            startCollapsed
          />
        )}
      </NodeTimeline.Item>

      <NodeTimeline.Item icon={<IconCircleX />} showStem={false} highlightIcon>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                Auto-issue failed
              </Text>
            }
            timestamp={manualTask?.createdAt}
          />
        </NodeTimeline.Title>

        {hasInvoiceData && (
          <>
            <Text {...Primary13Regular} color={GreyGrey70} marginBottom="16px">
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {getHumanReadableInvoiceNumber({
                  invoiceNumber: invoice.invoiceNumber,
                  invoiceStatus: invoice.status
                })}
              </Text>{' '}
              for{' '}
              <CustomerPreviewCardPill
                customerId={customer.id}
                data-testid="watchtower.notification.invoiceAutoIssueFailed.customerPill"
              />{' '}
              (
              {toMoney({
                value: invoice.grossTotal,
                currency: invoice.currency
              })}
              ) could not be issued automatically because the customer has no
              billing email. Add a billing email for{' '}
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {customer.legalName}
              </Text>
              , then issue the invoice.
            </Text>

            <InvoicePreviewCard
              invoice={invoice}
              customer={customer}
              invoiceDetails={invoiceDetails}
              action={
                <Button
                  as={Link.Unstyled}
                  to={invoicePaths.edit(invoice.id)}
                  variant="secondary"
                  style={{ flex: 1 }}
                  data-testid="watchtower.notification.invoiceAutoIssueFailed.viewInvoice"
                >
                  View invoice
                </Button>
              }
            />
          </>
        )}
      </NodeTimeline.Item>
    </>
  )
}
